import script from "./GameSettingsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./GameSettingsPanel.vue?vue&type=script&setup=true&lang=js"

import "./GameSettingsPanel.vue?vue&type=style&index=0&id=b2941074&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2941074"]])

export default __exports__